/**
 * Creates a function that will return the correct phrase based on the amount of elements.
 *
 * @param singular the phrase in singular
 * @param plural  the phrase in plural
 * @param other a default phrase for other cases (plural will be use if this is not provided)
 * @returns string
 */
export const getTextPluralized = (singular: string, plural: string, other?: string) => {
  return (number?: number) => {
    if (!number) return other || plural;
    if (number === 1) return singular;
    return plural;
  };
};
